import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import AuthProvider from '../../AuthProvider';

import ListaProblemas from './ListaProblemas';
import ListaAcessos from './ListaAcessos';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Admin" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (containsRole(['admin', 'sindico', 'conselheiro'])) {
              children.push(
                ListaProblemas
              );
            }

            if (containsRole(['admin', 'sindico'])) {
              children.push(
                ListaAcessos
              );
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/Index.js